import React, { useState } from 'react';
import { partial } from '../../../util/translation/translation';

const OPTIONS = ['a', 'b', 'c'];
const CORRECT = 'b';
const POINTS = 10;

/**
 * A quiz question in the app, clickable: pick an answer to see whether it
 * was right, the points and the place on the leaderboard. Example content.
 */
const QuizPreview = () => {
  const s = partial('shared');
  const [answer, setAnswer] = useState(null);
  const right = answer === CORRECT;

  return (
    <div className="tier-phone quiz-preview">
      <div className="heart-preview__head">
        <span aria-hidden>‹</span>
        {s('quizPreviewTitle')}
      </div>
      <div className="quiz-preview__body">
        <div className="quiz-preview__progress">
          <span>{s('quizPreviewStep', { step: 3, count: 5 })}</span>
          <span className="quiz-preview__bar" aria-hidden>
            <span style={{ width: '60%' }} />
          </span>
        </div>
        <div className="quiz-preview__question">
          <strong>{s('quizPreviewQuestion')}</strong>
          <span>{s('quizPreviewPoints', { points: POINTS })}</span>
        </div>
        <div className="quiz-preview__options">
          {OPTIONS.map((option) => {
            const state =
              answer &&
              (option === CORRECT
                ? ' quiz-preview__option--right'
                : option === answer
                  ? ' quiz-preview__option--wrong'
                  : '');
            return (
              <button
                key={option}
                type="button"
                className={`quiz-preview__option${state || ''}`}
                disabled={!!answer}
                onClick={() => setAnswer(option)}
              >
                {s(`quizPreviewOption-${option}`)}
              </button>
            );
          })}
        </div>
        {answer ? (
          <div
            className={`quiz-preview__result${
              right ? '' : ' quiz-preview__result--wrong'
            }`}
          >
            <strong>
              {right
                ? s('quizPreviewRight', { points: POINTS })
                : s('quizPreviewWrong')}
            </strong>
            <span>
              {s('quizPreviewPlace', { place: right ? 12 : 31, count: 248 })}
            </span>
            <button
              type="button"
              className="quiz-preview__again"
              onClick={() => setAnswer(null)}
            >
              {s('quizPreviewAgain')}
            </button>
          </div>
        ) : (
          <span className="quiz-preview__hint">{s('quizPreviewHint')}</span>
        )}
      </div>
    </div>
  );
};

export default QuizPreview;
